const content = {
  component: "FrontCover",
  cssClass: "front-cover",
  meta: {
    title: "Your Tomorrow, Today",
    description:
      "Your Tomorrow, Today is a magazine about innovation. We tell the stories of companies who push the envelope",
    og: {
      type: "website",
      title: "Read stories of tech innovation—see more",
      description: `Whether it's saving the lives of bees or scaling ethical chocolate start-ups, the possibilities of technology are endless. Click here to discover some of the most inspiring stories of digital transformation from across the world of business.`,
      image: require("../../assets/images/social/issue-main-1200x630.jpg")
    },
    twitter: {
      card: "summary",
      title:
        "Discover how technology is driving transformation across business",
      description: `From scaling Brazilian wine start-ups to transforming the olive oil supply chain, here are the stories of how pioneering technology is enabling businesses to thrive.`,
      site: "@Oracle",
      creator: "@Oracle",
      image: require("../../assets/images/social/issue-main-300x300.jpg")
    }
  },
  chip: "Issue 02",
  title: "Your Tomorrow, <strong>Today</strong>",
  subtitle:
    "Stories of innovative and forward-looking businesses solving tomorrow’s issues today.",
  ctaCopy: "Get started",
  heroImage: {
    preload: require("../../assets/images/bgs/issue-main-pre.jpg"),
    loaded: require("../../assets/images/bgs/issue-main.jpg"),
    mobile: require("../../assets/images/bgs/issue-main-mobile.jpg")
  }
};

export default content;
